<script lang='ts'>
  import { createEventDispatcher } from "svelte"
  import { Icon, Input, InputGroup, Popover } from "sveltestrap"
    import type { Procedence } from "../Model/Procedence"
    import type { Param } from "../Model/Param"
    import { paramsService, procedencesService } from "../services"

  const dispatch = createEventDispatcher();
  
  let procedences: Procedence[];
  let procedencesShow: Procedence[] = [];
  let paramsProcedence: Param[];
  let paramsAntecedent: Param[];

  let antecedentsShow: Param[] = [];

  export let searchFilterComponent = {
        thirdName : null,
        selectOrigin : null,
        selectAntecedent : null,
        date : null
    };

  let selectOrigin = null;
  let selectAntecedent = null;
  let selectDate = null;
  let startDate = null;
  let endDate = null;
  
  let date = new Date();

  let thirdName = null;

  function load(searchFilter) {
    dispatch('load', searchFilter);
  }

  loadInputDate();
  loadProcedences();
  loadAntecedents();

  async function loadProcedences() {

    paramsProcedence = await paramsService.findByType('modules');
    procedences = await procedencesService.find();

    const paramSelect = paramsProcedence.find(p => p.name == 'Registro de Antecedentes Externos');

    if (!paramSelect) {
      return;
    }

    for (const procedence of procedences) {
      if (procedence.moduleId == paramSelect.id) {
        procedencesShow.push(procedence)
      }
    }

    procedencesShow.sort((a, b) => {
      return a.name < b.name ? -1 : 1;
    });

    procedencesShow = procedencesShow;
  }

  async function loadAntecedents() {
    paramsAntecedent = await paramsService.findByType('antecedentType');

    for (const param of paramsAntecedent) {
        antecedentsShow.push(param);
    }

    antecedentsShow.sort((a, b) => {
      return a.name < b.name ? -1 : 1;
    });

    antecedentsShow = antecedentsShow;
  }

  function loadData(data, type) {
        if (type == 'thirdName') {
            searchFilterComponent.thirdName = data;
        } else if (type == 'selectOrigin') {
            searchFilterComponent.selectOrigin = null;
        } else if (type == 'selectAntecedent') {
            searchFilterComponent.selectAntecedent = data;
        }else {
            if (selectDate == null) {
                searchFilterComponent.date = data;
            } else{
                searchFilterComponent.date = data;
            }
            
        }
        load(JSON.stringify(searchFilterComponent));
    }

    function loadInputDate() {
        let startMonth = '0'; 
        let month = '0';
        if (date.getMonth() < 10 ) {
            month += date.getMonth()+1;
            startMonth += date.getMonth();
        } else {
            month = `${date.getMonth() + 1}`;
            startMonth = `${date.getMonth()}`;
        }
        let year = date.getFullYear()
        let day = date.getDate()

        startDate = year + '-' + startMonth + '-' + day;
        endDate = year + '-' + month + '-' + day;

        let selectedDates = [startDate, endDate];
        loadData(selectedDates,'date');
    }

    function replaceDate() {
            let popover = document.getElementById('popover');
            popover.hidden = true;
        
        let selectedDates = [startDate, endDate];
        loadData(selectedDates,'date');
    }

    function clearFilter() {
        searchFilterComponent = {
            thirdName : null,
            selectOrigin : null,
            selectAntecedent : null,
            date : null
        };
        thirdName = null;
        loadInputDate();
    }

</script>

<div class="container mt-3">
  <div class="row">
      <div class="col-3 col-sm-3 mb-3">
          <!-- Input para filtrar por nombre -->
          <form on:submit|preventDefault={() => loadData(thirdName, 'thirdName')}>
            <Input 
              placeholder='Encuentra un nombre'
              bind:value={thirdName}
            />
          </form>
      </div>
      <!-- Select para filtrar por procedencia -->
      <div class="col-3 col-sm-3 mb-3">
        <select bind:value={selectOrigin} on:change={() => loadData(selectOrigin, 'selectOrigin')} class='form-select'>
            <option selected value={null}>Seleccionar procedencia</option>
            {#each procedencesShow as procedence}
                <option value={procedence.id}>{procedence.name}</option>
            {/each}
        </select>
      </div>
      <!-- Select para filtrar por antecedente -->
      <div class="col-3 col-sm-3 mb-3">
          <select bind:value={selectAntecedent} on:change={() => loadData(selectAntecedent, 'selectAntecedent')} class='form-select'>
              <option selected value={null}>Seleccionar antecedente</option>
              {#each antecedentsShow as antecedent}
                  <option value={antecedent.id}>{antecedent.name}</option>
              {/each}
          </select>
      </div>
      <!-- Input para especificar el rango de fechas para filtrar -->
      <div class="col-3 col-sm-3 mb-3 d-flex">
            <button class='btn border border-dark' id='pop'>
                {startDate} - {endDate}
            </button>
            <Popover placement="bottom" target="pop" id='popover'>
                <div id='startDate'>
                    <p>Desde:</p>
                    <Input
                        type='date'
                        bind:value={startDate}
                    />
                </div>
                <div id='endDate'>
                    <p>Hasta</p>
                    <Input
                        type='date'
                        bind:value={endDate}
                    />
                </div>
                <button class='btn btn-primary mt-3' on:click={replaceDate}>Buscar</button>
            </Popover>

          <button class='btn btn-primary ms-1' on:click={clearFilter}><Icon name='eraser' /></button>
      </div>
  </div>
</div>